/* vehicle.js  ──  Handles Vehicle Details interactivity & validation.
 */
import { VEHICLE_TYPE_RULES } from '../../common/srt/srt-common-presets.js';
import { updateSuspensionOptions } from './srt-suspension.js';
import { updateTyreOptions } from './srt-tyres.js';
import { updateLoadOptions } from './srt-load.js';
import { updatePayloadLoadOptions } from './srt-tare-gross.js';

export function initVehicleSection(unitIdx = 0) {
   // Trigger the form logic for current vehicle type on page load
   const vt = $(`#vehicle-type-${unitIdx}`).val();
   if (vt) {
      updateFormForVehicleType(vt, unitIdx);
   }

   // vehicle-type change => rebuild based on ID suffix
   $('.vehicle-type-select').on('change', function () {
      // get selector for changed vehicle selector.
      const parts = this.id.split('-');
      const unitIdx = parseInt(parts[parts.length - 1], 10);
      const $type = $(`#vehicle-type-${unitIdx}`);
      const vt = $type.val();
      updateFormForVehicleType(vt, unitIdx);
   });
}

export function updateFormForVehicleType(vt, unitIdx) {
   // Vehicle details section and show/hide front column
   updateAxleWrappers(vt, unitIdx); // show/hide front/rear axles
   updateFormColumnsForVehicleType(vt, unitIdx); // show/hide front column based on vehicle type

   // Tyres Section
   updateTyreOptions(vt, unitIdx); // show/hide tyre options based on vehicle type

   // Payload Section
   updatePayloadLoadOptions(vt, unitIdx); // update gross/tare defaults based on vehicle type

   // Axle Load Section
   updateLoadOptions(vt, unitIdx); // clear advanced axle load fields and reset payload geometry

   // Suspension Section
   updateSuspensionOptions(vt, unitIdx); // populates selects with allowed suspension types and applies presets based on vehicle type

   // Icon
   updateUnitIcon(vt, unitIdx); // update the icon for the unit
}

// Update the front/rear axle inputs based on vehicle type rules
// This function updates the front and rear axle inputs based on the vehicle type rules.
// It enables/disables the inputs, sets min/max attributes, and applies default values.
function updateAxleWrappers(vt, unitIdx) {
   const $frontAxles = $(`#front-axles-${unitIdx}`);
   const $rearAxles = $(`#rear-axles-${unitIdx}`);
   const rule = VEHICLE_TYPE_RULES[vt];

   // Front axle logic
   if (rule.front.min === 0 && rule.front.max === 0) {
      $frontAxles.prop('disabled', true).val(0);
   } else {
      $frontAxles
         .prop('disabled', false) // Enables the input (removes 'disabled' property)
         .attr({ min: rule.front.min, max: rule.front.max }) // Sets 'min' and 'max' attributes
         .val(rule.front.default); // Sets the input's value to the default
   }
   // Rear axle logic (always shown for now)
   $rearAxles.prop('disabled', false).attr({ min: rule.rear.min, max: rule.rear.max }).val(rule.rear.default);
}

// Update the visibility of front columns based on vehicle type
// This function checks the vehicle type rules and toggles the visibility of front columns accordingly.
function updateFormColumnsForVehicleType(vType, unitIdx) {
   const rules = VEHICLE_TYPE_RULES[vType];
   if (!rules) {
      console.warn(`Unknown vehicle type: ${vType}, unit unitIdx: ${unitIdx}`);
      return;
   }

   // Show front columns only if min front axles > 0
   const showFront = rules.front.min > 0;
   toggleFrontColumns(showFront);
}

/**
 * Toggle visibility of front/rear columns for all units.
 * @param {boolean} showFront - true = show, false = hide
 */
function toggleFrontColumns(showFront) {
   $('.unit-columns').each(function () {
      const $unit = $(this);
      const $front = $unit.find('[data-col="front"]');
      if (showFront) {
         $front.show();
      } else {
         $front.hide();
      }
   });
}

/**
 * Optionally: toggle rear columns too if needed later
 */
function toggleRearColumns(showRear) {
   $('.unit-columns').each(function () {
      const $unit = $(this);
      const $rear = $unit.find('[data-col="rear"]');
      if (showRear) {
         $rear.show();
      } else {
         $rear.hide();
      }
   });
}

function updateUnitIcon(vt, unitIdx) {
   const icon = VEHICLE_TYPE_RULES[vt]?.icon || 'truck.svg';
   const iconPath = `/icons/${icon}`;

   const $unitItem = $(`#unitNav .unit-item`).eq(unitIdx);
   const $img = $unitItem.find('img');

   if ($img.length) {
      $img.attr('src', iconPath);
   }
}
